<div class="row mb-7">
    <div class="card">
        <div class="card-body lg:py-[1.25rem]">
            <ng-content></ng-content>
        </div>
    </div>
</div>